export function transformLitterReport(litterReport = []) {
    if (litterReport && litterReport.length) {
        return litterReport.map((report) => {
            return {
                ...report,
                location: `${JSON.parse(report.location).y}/${
                    JSON.parse(report.location).x
                }`,
                createdAt: new Date(report.createdAt).toDateString(),
            };
        });
    } else {
        return [];
    }
}
